module.exports = __webpack_public_path__ + "static/media/PCN.b2866afd.png";